import moment from 'moment';

const isSingleDayStayAtleast = (startTime, endTime) => {
  const durationInMilliseconds = endTime.diff(startTime);

  return moment.duration(durationInMilliseconds).asHours() >= 24;
};

export default isSingleDayStayAtleast;
